import React from 'react';

import CustomBaseEdge from 'components/ReactFlowChart/CustomBaseEdge';
import PropTypes from 'prop-types';

import styles from '../flowChart.module.css';

const AndEdge = ({ style, ...props }) => {
    const styleExtended = {
        stroke: '#9E77ED',
        strokeWidth: 2,
        ...style,
    };

    return (
        <CustomBaseEdge
            {...props}
            label="AND"
            labelClass={styles.andEdgeLabel}
            style={styleExtended}
        />
    );
};

AndEdge.propTypes = {
    style: PropTypes.object,
};

export default AndEdge;
